import { jsx as n } from "react/jsx-runtime";
import { c as s } from "./clsx.OuTLNxxd.js";
const a = ({ children: o, ...t }) => /* @__PURE__ */ n("button", { ...t, className: s("neu-link", t.className), type: "button", role: "button", children: o });
export {
  a as B
};
